import {Fragment} from 'react/jsx-runtime';
import styled from 'styled-components';
import {Button} from '@/components/Button';
import {Modal} from '@/components/Modal';
import {Typography} from '@/components/Typography';
import {Divider, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';

interface Content {
  title?: string;
  list: Array<{title?: string; desc: string}>;
}

interface IProps {
  title: string;
  content: Content[];
  onClose(): void;
}

export const DataInfoWindow = ({title, content, onClose}: IProps) => {
  return (
    <Modal title={title} width={400} onClose={onClose}>
      <PaddingBox spacing={16}>
        <Box>
          {content.map((i, idx) => (
            <Fragment key={idx}>
              <Box>
                {!!i.title && <Title>{i.title}</Title>}
                {!!i.list &&
                  i.list.map((j) => (
                    <div key={j.title}>
                      {!!j.title && <SubTitle>{j.title}</SubTitle>}
                      <Desc dangerouslySetInnerHTML={{__html: j.desc}} />
                    </div>
                  ))}
              </Box>
              {idx !== content.length - 1 && <Divider />}
            </Fragment>
          ))}
        </Box>
      </PaddingBox>
      <PaddingBox left={24} right={24} bottom={24}>
        <Button
          variant="fill"
          size="medium"
          color="secondary"
          fullWidth
          onClick={onClose}
        >
          확인
        </Button>
      </PaddingBox>
    </Modal>
  );
};

const Title = styled(Typography).attrs({
  color: palette.gray600,
  variant: 'medium20',
  as: 'div',
})`
  font-weight: 500;
`;

const SubTitle = styled(Typography).attrs({
  color: palette.gray800,
  variant: 'medium14',
  as: 'div',
})`
  font-weight: 700;
  margin-bottom: 4px;
`;

const Desc = styled(Typography).attrs({
  color: palette.gray600,
  variant: 'medium14',
  as: 'div',
  lineHeight: '20px',
})`
  font-weight: 500;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
